import React, { Component } from "react";
import FormationItem from "../../../../components/FormationItem/FormationItem";
import "./FormationsList.scss";
import { getAllTraining } from "../../../../api/training";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  setFormations,
  resetFormations,
} from "../../../../store/actions/formationsActions";

export class FormationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listFormations: this.props.formations.listFormations,
      lng: this.props.i18n.language
    };
  }

  componentDidMount() {
    this.getAllFormation();
  }

  componentDidUpdate(prevProps) {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language });
      this.getAllFormation();
    }

    if (
      prevProps.formations.listFormations !==
      this.props.formations.listFormations
    ) {
      this.setState({ brandsList: this.props.formations.listFormations });
    }
  }

  /**
   * Récupere toutes les formations disponible
   */
  getAllFormation() {
    // this.setState({ listFormations: [] });
    getAllTraining().then((data) => {
      this.setState({ listFormations: data });
      this.props.setFormations(data);
    });
  }

  render() {
    let { listFormations } = this.state;

    return (
      <div className="page_container">
        <div className="formations_list">
          {listFormations.map((item, index) => (
            <FormationItem
              key={index}
              idFormation={item.id}
              image={item.picture}
              title={item.title}
              brand={item.brand}
              points={item.points}
              time={item.time}
              formation={item.type}
              pourcent={item.pourcent}
            />
          ))}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFormations: (brands) => {
      dispatch(setFormations(brands));
    },
    resetFormations: () => {
      dispatch(resetFormations());
    },
  };
};

//extract data from the redux store
const mapStateToProps = (state) => ({
  formations: state.formations,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FormationsList));
